import React, {useState} from 'react';
import Box from '@/Atoms/Box';
import CCButton from '@/Atoms/CCButton';
import CCText from '@/Atoms/CCText';
import Divider from '@/Atoms/Divider/Divider';
import Spacer from '@/Atoms/Spacer';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {
  useGetRelationInvites,
  useUpdateRelationInvite,
} from '@/Hooks/UserAccessApi/useRequestUserRelations';
import CCColors from '@/Utils/CCColors';
import {FontSizes} from '@/Utils/Dimensions';
import {useNavigation} from '@react-navigation/native';
import {ScrollView, View, Image} from 'react-native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';
import Pagination from '../Games/Pagination';

const PendingRequest = ({userData, relationKey, handleRequestAccess}) => {
  const {isMobileOrTab} = useMediaQuery();
  const navigation = useNavigation();
  const [pendingRequestData, setPendingRequestData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [studentsPerPage] = useState(10);

  const {data: userPendingRequestData, refetch} = useGetRelationInvites(
    relationKey === 'Profile' ? 0 : 1,
    data => {
      setPendingRequestData(data?.invite_list || []);
    },
  );

  const {mutate: updateRelationInvite, isLoading: isUpdating} =
    useUpdateRelationInvite(
      data => {
        console.log('Success:', data);
        refetch();
      },
      error => {
        console.error('Error updating invite:', error);
      },
    );

  const titleHeaders = [
    {label: 'Player Details', key: 'playerDetails'},
    // {label: 'Phone Number', key: 'phoneNumber'},
    {label: 'User Name', key: 'userName'},
    {label: 'Access Granted of', key: 'accessGrantedOf'},
  ];

  const iconMapping = {
    Coach: 'school-outline',
    Parent: 'account-outline',
    Mentor: 'book-open-page-variant-outline',
  };

  const getInitials = (sender_name: string) => {
    const words = sender_name.trim().split(' ');
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return (words[0][0] + words[1][0]).toUpperCase();
  };

  const filteredPendingRequestData =
    relationKey === 'Profile'
      ? pendingRequestData
      : pendingRequestData.filter(item => item.invite_type === relationKey);

  const indexOfLastItem = currentPage * studentsPerPage;
  const indexOfFirstItem = indexOfLastItem - studentsPerPage;
  const currentItems = filteredPendingRequestData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(
    filteredPendingRequestData.length / studentsPerPage,
  );

  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  return (
    <>
      <ScrollView
        style={{
          margin: isMobileOrTab ? 10 : 0,
        }}
        showsVerticalScrollIndicator={false}>
        {currentItems?.length > 0 ? (
          <>
            <Box type="row-center-between" style={{padding: 24}}>
              {titleHeaders.map(header => (
                <Box key={header.key} style={{flex: 0.5}}>
                  <CCText
                    fontSize={FontSizes[14]}
                    color={CCColors.TextColor.Grey}
                    style={{lineHeight: 20, fontWeight: '500'}}>
                    {header.label}
                  </CCText>
                </Box>
              ))}
              {currentItems.map((student, index) => {
                const isReceiver =
                  userData?.username === student.receiver_username;
                const isLastIndex = index === currentItems.length - 1;

                return (
                  <React.Fragment key={student.invitation_key || index}>
                    <Box
                      style={{
                        width: isLastIndex
                          ? isReceiver
                            ? '25%'
                            : '10%'
                          : undefined,
                      }}
                    />
                  </React.Fragment>
                );
              })}
            </Box>

            {currentItems.map((student, index) => {
              const isReceiver =
                userData?.username === student.receiver_username;

              return (
                <React.Fragment key={student.invitation_key || index}>
                  <Divider width={1} />
                  <Box
                    type="row-center-between"
                    style={{
                      paddingVertical: 24,
                      paddingHorizontal: 32,
                    }}>
                    <Box type="row-flex-start" style={{gap: 12, flex: 0.5}}>
                      <View
                        style={{
                          width: 48,
                          height: 48,
                          borderRadius: 48,
                          backgroundColor: CCColors.CCTableBg,
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderWidth: 1,
                          borderColor: CCColors.TextColor.Grey,
                        }}>
                        <CCText
                          fontSize={FontSizes[24]}
                          style={{
                            lineHeight: 24,
                            fontWeight: '600',
                            fontFamily: 'Thunder',
                            marginBottom: -5,
                          }}>
                          {getInitials(
                            isReceiver
                              ? student.sender_name
                              : student.receiver_name,
                          )}
                        </CCText>
                      </View>
                      <View>
                        <CCText
                          fontSize={FontSizes[16]}
                          style={{lineHeight: 24, fontWeight: '500'}}
                          color={CCColors.Primary.Brown}>
                          {isReceiver
                            ? student.sender_name
                            : student.receiver_name}
                        </CCText>
                        <CCText
                          fontSize={FontSizes[14]}
                          style={{lineHeight: 24, fontWeight: '400'}}>
                          {student.rating}
                          {student.level ? ` | ${student.level}` : ''}
                        </CCText>
                      </View>
                    </Box>

                    <Box style={{flex: 0.5}}>
                      <CCText
                        fontSize={FontSizes[14]}
                        style={{lineHeight: 24, fontWeight: '500'}}
                        color={CCColors.TextColor.LightGrey}>
                        {isReceiver
                          ? student.sender_username
                          : student.receiver_username}
                      </CCText>
                    </Box>

                    {/* <Box style={{flex: 0.5}}>
                    <CCText
                      fontSize={FontSizes[14]}
                      style={{lineHeight: 24, fontWeight: '500'}}
                      color={CCColors.TextColor.LightGrey}>
                      {student.phone}
                    </CCText>
                  </Box> */}

                    <Box style={{flex: 0.5}}>
                      <View
                        style={{
                          borderWidth: 1,
                          borderColor: CCColors.Box.MiddleLine,
                          paddingHorizontal: 12,
                          paddingVertical: 4,
                          flexDirection: 'row',
                          alignItems: 'center',
                          gap: 6,
                          borderRadius: 12,
                          alignSelf: 'flex-start',
                        }}>
                        <MaterialCommunityIcons
                          name={iconMapping[student.invite_type]}
                          size={20}
                          color={CCColors.TextColor.LightGrey}
                        />
                        <CCText
                          fontSize={FontSizes[14]}
                          style={{lineHeight: 24, fontWeight: '500'}}
                          color={CCColors.TextColor.LightGrey}>
                          {student.invite_type}
                        </CCText>
                      </View>
                    </Box>

                    <View
                      style={{
                        width: isReceiver ? '25%' : '10%',
                        alignItems: 'center',
                        flexDirection: 'row',
                        gap: 10,
                      }}>
                      {isReceiver ? (
                        <>
                          <CCButton
                            style={{
                              borderWidth: 1,
                              borderColor: CCColors.BorderBottom,
                              backgroundColor: CCColors.White,
                            }}
                            onPress={() =>
                              updateRelationInvite({
                                update_type: 3,
                                invitation_key: student.invitation_key,
                              })
                            }>
                            <CCText
                              fontSize={FontSizes[14]}
                              color={CCColors.WrongMoves.Background}>
                              Reject
                            </CCText>
                          </CCButton>
                          <CCButton
                            onPress={() =>
                              updateRelationInvite({
                                update_type: 4,
                                invitation_key: student.invitation_key,
                              })
                            }>
                            <CCText fontSize={FontSizes[14]}>Accept</CCText>
                          </CCButton>
                        </>
                      ) : (
                        <CCButton
                          onPress={() =>
                            updateRelationInvite({
                              update_type: 2,
                              invitation_key: student.invitation_key,
                            })
                          }
                          style={{
                            borderWidth: 1,
                            borderColor: CCColors.BorderBottom,
                            backgroundColor: CCColors.White,
                          }}>
                          <CCText fontSize={FontSizes[14]}>Cancel</CCText>
                        </CCButton>
                      )}
                    </View>
                  </Box>
                </React.Fragment>
              );
            })}
          </>
        ) : (
          <View style={{alignItems: 'center', justifyContent: 'center'}}>
            <Image
              source={require('@/Assets/Images/RequestAccess/NoPlayer.svg')}
              alt="No Students Found"
              style={{width: 180, height: 180, marginBottom: 20}}
              resizeMode="contain"
            />
            <Spacer spacing={20} />
            <CCText
              fontSize={FontSizes[16]}
              color={CCColors?.TextColor?.Dark}
              style={{lineHeight: 20, fontWeight: '500'}}>
              No player access added to your profile yet
            </CCText>
            <Spacer spacing={10} />
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors?.TextColor?.Primary}
              style={{
                lineHeight: 20,
                fontWeight: '400',
                textAlign: 'center',
              }}>
              Click the CTA below to request player{'\n'}profile access
            </CCText>
            <Spacer spacing={20} />
            <CCButton
              titleStyle={{
                fontSize: FontSizes[16],
                color: CCColors.TextColor.Primary,
              }}
              style={{backgroundColor: CCColors.Primary.Action}}
              onPress={handleRequestAccess}>
              + Request Access
            </CCButton>
          </View>
        )}
      </ScrollView>
      {currentItems?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          paginate={paginate}
        />
      )}
    </>
  );
};

export default PendingRequest;
